<template>
  <!-- import styles if needed -->
  <PageLoader class="mb-5 mt-5" v-if="isLoading"></PageLoader>
  <div v-if="is_loaded" v-show="!isLoading">
    <!-- import styles if needed -->

    <div v-if="is_loaded">
      <div id="current-user-wrapper">
        <snipp-current-user
          :campaign-id="campaignId"
          :user-status="user_status"
          @show-registration="showRegistration"
          @snipp-logout="handleSnippLogout"
          @show-confirmation="showConfirmation"
          @current-user="handleCurrentUser"
          :custom-css="customCssUrl"
          referral-source="Kroger"
          :language="$t('Language')"
        ></snipp-current-user>
      </div>
      <div
        id="registration-wrapper"
        v-if="registration_enabled"
        ref="registrationSection"
      >
        <snipp-registration
          app-source="CampaignWidget"
          refresh-reload="true"
          :campaign-id="campaignId"
          :show-confirmation="show_confirmation"
          :custom-css="customCssUrl"
          :is-logged-out="is_logged_out"
          @is-registered="handleIsRegistered"
          referral-source="Kroger"
          :language="$t('Language')"
        ></snipp-registration>
      </div>
      <div
        id="thanks-text"
        v-if="upload_enabled === 'upload_again'"
        ref="thanksSection"
      >
        <br />
        <h1 class="mb-3">{{ $t('IPEwidget.ThanksTitle') }}</h1>
        <p v-html="$t('IPEwidget.ThanksDesc')"></p>
        <p v-html="$t('IPEwidget.TermsLink')" class="d-none"></p>
        <br />
      </div>
      <div id="upload-wrapper" v-if="upload_enabled" ref="uploadSection">
        <div id="upload-original" v-if="upload_enabled !== 'upload_again'">
          <div class="hide-dlr">
            <h2 class="text-center my-4">
              {{ $t('IPEwidget.UploadReceiptTitle') }}
            </h2>
          </div>
          <div class="show-dlr" style="display: none">
            <h2 class="text-center my-4">{{ $t('IPEwidget.DLRTitle') }}</h2>
          </div>
          <div
            v-html="$t('IPEwidget.ImageUploadDesc1')"
            class="mt-4 mb-0 hide-dlr"
          ></div>
          <div
            v-html="$t('IPEwidget.ImageUploadDesc2')"
            class="mt-4 mb-0 hide-dlr"
          ></div>
          <div
            v-html="$t('IPEwidget.ImageUplaodInstruction')"
            class="mt-4 mb-4 hide-dlr"
          ></div>

          <snipp-upload
            :campaign-id="campaignId"
            include-upload-button="true"
            @snipp-upload-result="handleSnippUploadResult"
            @snipp-widget-event="handleSnippWidgetEvent"
            :custom-css="customCssUrl"
            referral-source="Kroger"
            :language="$t('Language')"
          ></snipp-upload>
          <div class="my-5 text-center hide-dlr">
            <p v-html="$t('IPEwidget.PP')" class="fw-bold mb-2"></p>
            <p><small v-html="$t('Home.ParticipatingProductLink')"></small></p>
          </div>
        </div>
        <div id="upload-again" v-if="upload_enabled === 'upload_again'">
          <snipp-upload
            :campaign-id="campaignId"
            include-upload-again-button="true"
            @snipp-upload-result="handleSnippUploadResult"
            :custom-css="customCssUrl"
            referral-source="Kroger"
            :language="$t('Language')"
          ></snipp-upload>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageLoader from '../../../components/UI/PageLoader.vue';
export default {
  components: { PageLoader },
  props: ['campaignId'],
  emits: [],
  data() {
    return {
      ts: Date.now(),
      isLoading: true,
      is_loaded: false,
      is_logged_out: undefined,
      upload_enabled: undefined,
      registration_enabled: false,
      show_confirmation: undefined,
      user_status: undefined,
      uploadLimitReached: false,
      showDlr: false,
      customCssUrl: window.location.origin + '/assets/css/custom_overrides.css',
      gateState:
        sessionStorage.getItem('State') ||
        sessionStorage.getItem('selectedState') ||
        undefined,
    };
  },
  methods: {
    findInShadowTree(root, id) {
      if (!root) return null;
      const direct = root.getElementById ? root.getElementById(id) : null;
      if (direct) return direct;

      const all = root.querySelectorAll ? root.querySelectorAll('*') : [];
      for (const el of all) {
        if (el.shadowRoot) {
          const found = this.findInShadowTree(el.shadowRoot, id);
          if (found) return found;
        }
      }
      return null;
    },
    findInShadowTreeBySelector(root, selector) {
      if (!root) return null;
      const direct = root.querySelector ? root.querySelector(selector) : null;
      if (direct) return direct;

      const all = root.querySelectorAll ? root.querySelectorAll('*') : [];
      for (const el of all) {
        if (el.shadowRoot) {
          const found = this.findInShadowTreeBySelector(
            el.shadowRoot,
            selector
          );
          if (found) return found;
        }
      }
      return null;
    },
    async prefillIpeGateData() {
      const stateVal =
        this.gateState ||
        sessionStorage.getItem('State') ||
        sessionStorage.getItem('selectedState');
      if (!stateVal) return;

      let stateDone = false;

      for (let i = 0; i < 40; i++) {
        const root = document.querySelector('snipp-registration')?.shadowRoot;
        if (root) {
          const select =
            this.findInShadowTree(root, 'dropdown_state') ||
            root.querySelector('select[name="state"], select#state');
          if (select) {
            select.value = stateVal;
            if (select.value !== stateVal) {
              const match = Array.from(select.options || []).find(
                (opt) =>
                  opt.value.toLowerCase() === stateVal.toLowerCase() ||
                  opt.textContent.trim().toLowerCase() ===
                    stateVal.toLowerCase()
              );
              if (match) select.value = match.value;
            }
            select.dispatchEvent(new Event('input', { bubbles: true }));
            select.dispatchEvent(new Event('change', { bubbles: true }));
            select.disabled = true;
            select.setAttribute('aria-disabled', 'true');
            stateDone = true;
          }
          if (stateDone) return;
        }
        await new Promise((r) => setTimeout(r, 150));
      }
    },
    async updateOfficialRuleLink() {
      for (let i = 0; i < 40; i++) {
        const root = document.querySelector('snipp-registration')?.shadowRoot;
        const termsLink = this.findInShadowTreeBySelector(
          root,
          'label[for="checkbox_terms"] a'
        );
        const consentLink = this.findInShadowTreeBySelector(
          root,
          'label[for="checkbox_consent"] a'
        );
        const privacyLink = this.findInShadowTreeBySelector(
          root,
          'label[for="checkbox_terms"] a:nth-of-type(2)'
        );
        if (termsLink) {
          termsLink.setAttribute('href', 'http://snipp.us/!cuYYz');
        }
        if (consentLink) {
          consentLink.setAttribute('href', 'http://snipp.us/!cuYZT');
        }
        if (privacyLink) {
          privacyLink.setAttribute('href', 'http://snipp.us/!cuYZT');
        }
        if (termsLink || consentLink || privacyLink) return;

        await new Promise((resolve) => setTimeout(resolve, 150));
      }
    },
    showRegistration(confirmation) {
      if (this.upload_enabled) this.upload_enabled = undefined;
      if (confirmation) {
        this.show_confirmation = true;
      } else {
        this.show_confirmation = undefined;
      }
      this.registration_enabled = true;
      this.$nextTick(() => {
        this.$refs.registrationSection?.scrollIntoView({ behavior: 'smooth' });
        this.prefillIpeGateData();
        this.updateOfficialRuleLink();
      });
    },
    showConfirmation() {
      this.showRegistration(true);
    },
    handleSnippLogout() {
      this.upload_enabled = undefined;
      this.is_logged_out = true;
      this.showRegistration();
    },
    handleIsRegistered() {
      this.user_status = Date.now();
      this.upload_enabled = 'upload';
      this.registration_enabled = false;
      this.$nextTick(() => {
        this.$refs.uploadSection?.scrollIntoView({ behavior: 'smooth' });
      });
    },
    handleSnippUploadResult() {
      this.upload_enabled = 'upload_again';
      this.$nextTick(() => {
        this.$refs.thanksSection?.scrollIntoView({ behavior: 'smooth' });
      });
    },
    handleSnippWidgetEvent(e) {
      // check inside event
      if (e && e.detail && e.detail.length) {
        let message = e.detail[0];
        this.uploadLimitReached = true;
        const elements2 = document.querySelectorAll('.show-dlr');
        if (message.upload_limit_reached) {
          this.showDlr = true;
          const elements = document.querySelectorAll('.hide-dlr');
          elements.forEach((el) => {
            el.style.display = 'none';
          });

          elements2.forEach((el) => {
            el.style.display = 'block';
          });
        } else {
          elements2.forEach((el) => {
            el.style.display = 'none';
          });
        }
      }
    },
    handleCurrentUser() {
      this.registration_enabled = false;
      this.upload_enabled = 'upload';
    },
  },
  mounted() {
    this.is_loaded = true;
    setTimeout(() => (this.isLoading = false), 1500);
    this.prefillIpeGateData();
    this.updateOfficialRuleLink();
  },
  watch: {
    registration_enabled(val) {
      if (val) {
        this.$nextTick(() => {
          this.prefillIpeGateData();
          this.updateOfficialRuleLink();
        });
      }
    },
  },
};
</script>

<style scoped>
.wrapper {
  margin-top: 57px;
}

.color-red {
  color: #bf233a;
}

#current-user-wrapper,
#upload-wrapper {
  max-width: 48%;
  margin: 0 auto;
}

@media screen and (max-width: 575px) {
  #current-user-wrapper,
  #upload-wrapper {
    max-width: 100%;
    margin: 0 auto;
  }
}
</style>
